module.exports = __webpack_public_path__ + "static/img/returnhead.4bf5b3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/returnhead.png
// module id = lN4P
// module chunks = 0